import { render, staticRenderFns } from "./FundManagerMixChart.vue?vue&type=template&id=ce223fd6&"
import script from "./FundManagerMixChart.vue?vue&type=script&lang=ts&"
export * from "./FundManagerMixChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports